import { AnalyticsElement, AnalyticsOptions } from '@typesApp/Analytics'

type Attributes = {
  id: 'InsurancePanel_Submit' | 'InsurancePanel_Download' | 'InsurancePanel_MoreInfo' | 'InsurancePanel_StartClaim'

  description?: string
  availableCall?: string
}

const ELEMENT_MAP = {
  [AnalyticsElement.SUBMIT]: {
    id: 'InsurancePanel_Submit',
  },
  [AnalyticsElement.DOWNLOAD]: {
    id: 'InsurancePanel_Download',
  },
  [AnalyticsElement.MORE_INFO]: {
    id: 'InsurancePanel_MoreInfo',
  },
  [AnalyticsElement.START]: {
    id: 'InsurancePanel_StartClaim',
  },
  [AnalyticsElement.CANCEL]: {
    availableCall: '0',
  },
  [AnalyticsElement.CONTINUE]: {
    availableCall: '0',
  },
  [AnalyticsElement.CLOSE]: {
    availableCall: '0',
  },
  [AnalyticsElement.OTHER]: {
    availableCall: '0',
  },
} as Record<AnalyticsElement, Attributes>

/**
 * Create insurance analytics data-* attributes based on this guide.
 *
 * https://docs.google.com/document/d/1xm8EDm6Y5NF70_uqUerhvAi2DHuW59Gtddf16kkLGCw/edit#heading=h.d96ruinxj4yq
 */

export const injectAnalytics = (type: AnalyticsElement, options?: AnalyticsOptions): Record<string, string> => {
  const attributes = ELEMENT_MAP[type]

  const result = {} as Record<string, string>

  if (type && [AnalyticsElement.START, AnalyticsElement.SUBMIT, AnalyticsElement.DOWNLOAD].includes(type)) {
    result['data-element-id'] = `${attributes.id}`
  } else if (attributes?.id) {
    result['data-element-id'] =
      `${options?.index !== undefined && options?.index >= 0 ? options?.index : ''}${attributes.id}`
  }

  if (options?.description || attributes?.description) {
    result['data-description'] = options?.description || attributes.description || ''
  }

  if (attributes?.availableCall) {
    result['data-analytics_available_call'] = attributes.availableCall
  }
  return result
}
